import {
  calculateLRC,
  commandCode,
  getHexLengthBytes,
  getPayloadLengthBytes,
  toHex,
} from './utils';

const readyToPrintResponse = () => {
  const messageIdentifier = toHex('V2');

  const requestMessage = [];
  requestMessage.push(commandCode.READY_TO_PRINT_RESPONSE);
  requestMessage.push('OK');

  const payload = Buffer.from(requestMessage.join());
  const payloadHex = payload.toString('hex');

  const calculatedLRC = calculateLRC(payloadHex);
  const payloadLengthBytes = getPayloadLengthBytes(payload.length);
  const hexLengthBytes = getHexLengthBytes(payloadLengthBytes);
  const buffer = messageIdentifier + hexLengthBytes + payloadHex + calculatedLRC;

  return buffer;
};

export { readyToPrintResponse };
